import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { Tables, hashCode } from "@repo/utils";
import { useEstimateStructure, useTableExpandHandler, TableTitle } from "@tools";
import { SortableList } from "@components";
import { Collapse } from "@material-ui/core";
import { BudgetTrackingSection } from "./components/BudgetTrackingSection";
import useStyle from "@tools/EstimateEditor/styles/CommonTableStyles.style";
import classnames from "classnames";

export const BudgetTrackingTableBreakdown = observer(() => {
  const structure = useEstimateStructure();
  const classes = useStyle();
  const { t } = useTranslation();

  const { sections, settings } = structure;
  const { showBreakdown } = settings;

  const handleSectionReorder = (list) => structure.reorderSections(list);
  
  const { ...collapseProps } = useTableExpandHandler({
    expandable: true,
    isOpened: showBreakdown,
    onExpand: settings.setShowBreakdown
  });

  return (
    <>
      <TableTitle
        presetClass="breakdown"
        id={hashCode(Tables.BREAKDOWN)}
        title={t("views.bt.title")}
        className="preset-page preset-noedit"
      />
      <Collapse
        in={showBreakdown}
        timeout="auto"
        className={classnames(classes.collapse)}
        mountOnEnter
        unmountOnExit
        data-id={hashCode("cont")}
        data-t={ Tables.BREAKDOWN }
        data-p={hashCode(Tables.BREAKDOWN)}
        {...collapseProps}
      >
        <SortableList
          list={sections}
          group="sections"
          onListReorder={handleSectionReorder}
          disabled
          className={classes.tableContainerWrapper}
        >
          {
            sections
              .filter((ob) => !ob.isTurnedOff )
              .map((section, index) => (
                <BudgetTrackingSection
                  key={section.id}
                  section={section}
                  index={index}
                />
              ))
          }
        </SortableList>
      </Collapse>
    </>
  );
});